import { render, staticRenderFns } from "./FundView.vue?vue&type=template&id=6cf03e88&scoped=true&"
import script from "./FundView.vue?vue&type=script&lang=ts&"
export * from "./FundView.vue?vue&type=script&lang=ts&"
import style0 from "./FundView.vue?vue&type=style&index=0&id=6cf03e88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf03e88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFadeTransition,VRow,VSpacer})
